import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { ApiService } from "../services";
import { setOrderDetails, setOrderPlaced, setRazorpayDetails } from "../store";
import { API_SUCCESS_CODES } from "../constants";

export function useOrderEventMutation() {
  const { user, order } = useSelector((state) => state);

  return useMutation({
    mutationFn: async ({ shippingAddressId, billingAddressId }) => {
      const response = await ApiService.patch(
        `${order.shopDomain}/order/${order.orderDetails.id}/order-event`,
        {
          shippingAddressId,
          billingAddressId,
          userShopifyId: user?.shopifyDetails?.shopifyId || null
        },
        { authorization: `Bearer ${user.authToken}` }
      );
      if (!API_SUCCESS_CODES.includes(response.statusCode))
        throw new Error("Invalid request, something went wrong!");

      return response.data;
    }
  });
}

export function usePlaceOrderMutation() {
  const dispatch = useDispatch();
  const { user, order } = useSelector((state) => state);

  return useMutation({
    mutationFn: async ({ paymentMode }) => {
      const body = {
        paymentMode: paymentMode === "credit" ? "online" : "cod",
        paymentGateway: paymentMode === "credit" ? "razorpay" : "cod"
      };

      const response = await ApiService.post(
        `${order.shopDomain}/order/${order.orderDetails.id}/complete`,
        body,
        { authorization: `Bearer ${user.authToken}` }
      );

      if (!API_SUCCESS_CODES.includes(response.statusCode))
        throw new Error("Invalid request, something went wrong!");

      return response;
    },
    onSuccess: (response) => {
      dispatch(setOrderDetails(response.data.order));
      if (response.data?.gatewayRes) {
        dispatch(setRazorpayDetails(response.data.gatewayRes));
      }
    }
  });
}

export function useVerifyOrderMutation() {
  const dispatch = useDispatch();
  const { user, order } = useSelector((state) => state);

  return useMutation({
    mutationFn: async (payload) => {
      const response = await ApiService.post(
        `${order.shopDomain}/order/${order.orderDetails.id}/verify`,
        {
          razorpayPaymentId: payload.razorpay_payment_id,
          razorpaySignature: payload.razorpay_signature
        },
        { authorization: `Bearer ${user.authToken}` }
      );
      if (!API_SUCCESS_CODES.includes(response.statusCode))
        throw new Error("Invalid request, order creation failed!");

      return response;
    },
    onSuccess: () => {
      dispatch(setOrderPlaced());
    }
  });
}
